// material-ui
import { alpha, createTheme } from "@mui/material/styles";

// third-party
import { presetDarkPalettes, presetPalettes } from "@ant-design/colors";

// project import
import ThemeOption from "./theme";
import { ThemeMode } from "config";

// ==============================|| DEFAULT THEME - PALETTE ||============================== //

export default function Palette(mode, presetColor) {
  const colors = mode === ThemeMode.DARK ? presetDarkPalettes : presetPalettes;

  let greyPrimary = [
    "#ffffff",
    "#fafafa",
    "#f5f5f5",
    "#f0f0f0",
    "#d9d9d9",
    "#bfbfbf",
    "#8c8c8c",
    "#595959",
    "#262626",
    "#141414",
    "#000000",
  ];
  let greyAscent = ["#fafafa", "#bfbfbf", "#434343", "#1f1f1f"];
  let greyConstant = ["#fafafb", "#e6ebf1"];

  if (mode === ThemeMode.DARK) {
    greyPrimary = [
      "#000000",
      "#141414",
      "#1e1e1e",
      "#595959",
      "#8c8c8c",
      "#bfbfbf",
      "#d9d9d9",
      "#f0f0f0",
      "#f5f5f5",
      "#fafafa",
      "#ffffff",
    ];
    // greyPrimary.reverse();
    greyAscent = ["#fafafa", "#bfbfbf", "#434343", "#1f1f1f"];
    greyConstant = ["#121212", "#d3d8db"];
  }
  colors.grey = [...greyPrimary, ...greyAscent, ...greyConstant];

  const paletteColor = ThemeOption(colors, presetColor, mode);

  return createTheme({
    palette: {
      mode,
      common: {
        black: "#000",
        white: "#fff",
      },
      ...paletteColor,
      text: {
        primary:
          mode === ThemeMode.DARK
            ? alpha(paletteColor.grey[900], 0.87)
            : "#1A1A18",
        secondary:
          mode === ThemeMode.DARK
            ? alpha(paletteColor.grey[900], 0.45)
            : "#5F5E5A",
        disabled:
          mode === ThemeMode.DARK
            ? alpha(paletteColor.grey[900], 0.1)
            : "#B4B2A9",
      },
      primary: {
        ...paletteColor.primary,
        main: "#0F6E56",
        dark: "#085041",
        light: "#1D9E75",
      },
      secondary: {
        ...paletteColor.secondary,
        main: "#BA7517",
        dark: "#854F0B",
        light: "#EF9F27",
      },
      success: { ...paletteColor.success, main: "#3B6D11" },
      warning: { ...paletteColor.warning, main: "#BA7517" },
      error: { ...paletteColor.error, main: "#A32D2D" },
      action: {
        disabled: paletteColor.grey[300],
      },
      divider:
        mode === ThemeMode.DARK
          ? alpha(paletteColor.grey[900], 0.05)
          : "rgba(0,0,0,0.06)",
      background: {
        paper: mode === ThemeMode.DARK ? paletteColor.grey[100] : "#FFFFFF",
        default: "#F4F4F2",
      },
    },
  });
}
